export default __webpack_public_path__ + "static/media/logo.976b3ae9.jpg";